function equalizeHeights() {
    if (window.innerWidth <= 750) {
      // Reset min-heights if below 750px
      document.querySelectorAll('.js-equal-height').forEach(container => {
        container.querySelectorAll('.js-equlize').forEach(el => {
          el.style.minHeight = '0';
        });
      });
      return;
    }
  
    const containers = document.querySelectorAll('.js-equal-height');
    if (!containers.length) return;
  
    containers.forEach(container => {
      const elements = container.querySelectorAll('.js-equlize');
      if (!elements.length) return;
  
      let maxHeight = 0;
  
      elements.forEach(el => el.style.minHeight = '0');
  
      elements.forEach(el => {
        const height = el.offsetHeight;
        if (height > maxHeight) maxHeight = height;
      });
  
      elements.forEach(el => el.style.minHeight = maxHeight + 'px');
    });
  }
  
  window.addEventListener('load', equalizeHeights);
  window.addEventListener('resize', equalizeHeights);
  